import React from 'react';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import { switchRoutes } from './router';
import { AutoLoginLoggedScene, DocumentalScene } from 'scenes';
export const RouterLogged = () => {
    const location = useLocation();
    return (React.createElement(Switch, { location: location },
        React.createElement(Route, { path: [switchRoutes.autologin.base, switchRoutes.autologin.external] },
            React.createElement(AutoLoginLoggedScene, null)),
        React.createElement(Route, { exact: true, path: [switchRoutes.root, switchRoutes.upload] },
            React.createElement(DocumentalScene, null)),
        React.createElement(Route, { path: '*' },
            React.createElement(Redirect, { to: switchRoutes.upload }))));
};
